import moment from "moment";
import React, { useState, useContext, useEffect } from "react";
import "moment/locale/zh-cn";
import "moment/locale/zh-hk";

const LanguageContext = React.createContext({ language: 'en', changeLanguage: (lang) => {} });
export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    // Fallback if context is not available
    console.warn('[LanguageContext] Context not available, using default language');
    return { language: 'en', changeLanguage: (lang) => {} };
  }
  return context;
};

export default function LanguageContextPrivider({ children }) {
  const [language, changeLanguage] = useState(
    () => (typeof localStorage !== "undefined" && localStorage.getItem("language")) || "en"
  );
  const momentLocale =
    language === "en" ? "en" : language === "cn" ? "zh-cn" : "zh-hk";

  useEffect(() => {
    changeLanguage(localStorage.getItem("language") || "en");
  }, []);

  moment.locale(momentLocale);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
